<script setup>
    import {
        useRouter
    } from 'vue-router';
    import {
        Fold,
        Expand,
        BellFilled,
        ArrowDown,
        ArrowRight
    } from '@element-plus/icons-vue';
    import {
        ElMessage,
        ClickOutside as vClickOutside
    } from 'element-plus';
    import {
        computed,
        onMounted,
        ref,
        unref,
        inject,
        watch,
        onBeforeUnmount
    } from 'vue';
    import {
        useStore
    } from 'vuex';
    import {
        require
    } from '@/utils/index';

    const emit = defineEmits(['toggle-mobile-menu']);
    import {
        getFontMsgApi
    } from '@/apis/common';
    import {
        Vue3Marquee
    } from 'vue3-marquee';
    import Breadcrumb from '@/components/layout/Breadcrumb.vue';
    import language from '@/components/center/language.vue';
    import profile_notice from '@/assets/images/center/profile_notice.png';
    import profile_avatar from '@/assets/images/center/profile_avatar.png';
    import {
        readContent
    } from '@/apis/common'

    const langrage = inject('langrage');
    const router = useRouter();
    const store = useStore();
    const sidebarOpen = computed(() => store.state.sidebarOpen);
    const userInfo = computed(() => store.state.user.userInfo);
    const notificationVisible = ref(false)
    const toggleNotificationPanel = () => {
        notificationVisible.value = !notificationVisible.value
    }
    const userMessage = computed(() =>
        store.state.user.userMessage
    )
    console.log('主页数据', store.state.user.userMessage);
    const badge = ref('')
    watch(userMessage, (nv) => {
        if (nv.length) {
            badge.value = 0
            nv.forEach(el => {
                if (el.isRead == 2) {
                    badge.value = Number(badge.value) + 1
                }
            });
            if (!badge.value) {
                badge.value = ''
            }
        } else {
            badge.value = ''
        }
        // nv.length ? badge.value = nv.length : badge.value = ''
        // badge.value = nv.length
    }, {
        deep: true
    })
    const fontMsg = ref({});
    const fontFamily = ref('');
    const subUser = ref(userInfo.value?.user);
    const lang = localStorage.getItem('langrage');
    const visible = ref(false)
    console.log('userInfo:', subUser);
    const handleCommand = (command) => {
        ElMessage(`click on item ${command}`);
    };

    const changeSidebar = () => {
        store.commit('TOGGLE_SIDEBAR');
    };

    const jumpPage = (path) => {
        router.push(path);
        setTimeout(() => {
            location.reload();
        }, 100);
    };

    // 获取公告信息
    const getFontMsg = async () => {
        try {
            const {
                data,
                code,
                msg
            } = await getFontMsgApi();
            fontMsg.value = data;
            fontFamily.value = `'Be Vietnam Pro', 'source-han-sans', sans-serif`;
        } catch (error) {
            console.error(error);
        }
    };

    const changeType = async (item) => {
        console.log('先进入');


        let Timer = null

        if (item.isRead == 2) {
            //先前端改变状态,让使用变得丝滑
            store.commit('user/CHANGE_MESSAGE_TYPE', item.id)
            //然后找到传来的id,调接口把未读变为已读
            await readContent({
                userId: userInfo.value.user.userId,
                id: item.id
            })
            //要做个防抖,我们只更新最后一次的消息数据,防止点了未读马上调接口回头影响其他数据
            if (Timer) {
                clearTimeout(Timer)
            }
            Timer = setTimeout(async () => {
                //获取铃铛信息
                await store.dispatch('user/getRemindContent');
            }, 500)
        } else if (!item) {
            //如果传的是空就是一键已读,调接口
            console.log(1, '如果不存在item');
            visible.value = false
            await readContent({
                userId: userInfo.value.user.userId,
                id: null
            })
            console.log(2);
            //获取铃铛信息
            await store.dispatch('user/getRemindContent');
            console.log(3);

        }

    }
    const goMessage = () => {
        router.push('/account/profile');
    };
    const checkIn = async () => {
        //localStorage.clear();
        await store.dispatch('user/logout');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('response');
        localStorage.removeItem('token');
        window.location.reload();
    };
    const isMobile = ref(false)
    const MOBILE_BREAKPOINT = 1024

    // 检查屏幕宽度的函数
    const checkScreenSize = () => {
        isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT
    }

    // 监听窗口大小变化
    const handleResize = () => {
        checkScreenSize()
    }

    onMounted(() => {
        getFontMsg();
        const dropDownTrigger = document.getElementById('popover')
        console.log(dropDownTrigger);

        dropDownTrigger.addEventListener('mouseenter', () => {
            console.log(121212);
            visible.value = true
            console.log('userMessage1', userMessage);
            console.log('userMessage2', store.state.user.userMessage);
        });
        dropDownTrigger.addEventListener('mouseleave', () => {
            if (!store.state.user.userMessage.length) {
                visible.value = false
            }
        });
        checkScreenSize()
        window.addEventListener('resize', handleResize)

    });
    // 组件卸载前移除事件监听器
    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })
</script>

<template>
    <div class="navbar">
        <div class="left flex-center">
            <!-- 桌面端显示原来的菜单按钮 -->
            <!-- <div class="icon" @click="changeSidebar" v-if="!isMobile">
                <img :style="{
                    transform: sidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }" src="@/assets/images/center/menuFold.png" alt="" />
            </div> -->

            <!-- 移动端显示汉堡菜单按钮 -->
            <div class="mobile-menu-icon" @click="$emit('toggle-mobile-menu')" v-if="isMobile">
                <img src="@/assets/images/center/menuFold.png" alt="" />
            </div>

            <!-- 桌面端显示面包屑 -->
            <div v-if="!isMobile">
                <Breadcrumb />
            </div>
        </div>

        <!-- 桌面端显示公告 -->
        <div class="tips" style="font-size: 1.4rem; width: 92rem" v-if="!isMobile">
            <!-- <Vue3Marquee :duration="lang == 'chinese' ? fontMsg.flowSecond : fontMsg.flowSecond2" :pauseOnHover="true">
                <span v-if="lang == 'chinese'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo
                    }}</span>
                <span v-if="lang == 'english'" :style="{ fontFamily: fontFamily, color: fontMsg.colors }">{{
                    fontMsg.valueInfo2
                    }}</span>
            </Vue3Marquee> -->
        </div>

        <div class="right flex-center">
            <!-- 桌面端显示的内容 -->
            <template v-if="!isMobile">
                <!-- <div style="height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 1rem;">
                    <img style="cursor: pointer; width: 4rem" :src="require('@/assets/images/center/kefu.png')" alt="">
                </div> -->
                <div class="select flex-center">
                    <language />
                </div>
                <!-- 消息拉框 -->
                <el-popover :visible="visible" placement="bottom" 
                 popper-class="message-box"
                 :width="360" :height="300">
                    <div class="popover_content">
                        <p class="popover_title">{{
                            langrage['dashboard31'] }}</p>
                        <div class="popover_tip_content">
                            <div v-if="userMessage.length" class="popover_text_content"
                                v-for="(item, index) in userMessage" :key="index">
                                <div class="num_content">
                                    <p class="num">{{ index + 1 }}</p>
                                    <p class="popover_text">
                                        {{ item.pushInfo }}
                                    </p>
                                </div>
                                <div class="popover_type" @click="changeType(item)"
                                    :class="item.isRead == 2 ? 'blue' : ''">
                                    <!-- 35已读36未读 -->
                                    {{ item.isRead == 2 ? langrage['dashboard36'] :
                                        langrage['dashboard35']
                                    }}
                                </div>
                            </div>
                            <!-- 暂无消息 -->
                            <div v-else class="empty-container">
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
                                <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
                              </svg>
                              <div>{{ langrage['dashboard38'] }}</div>
                            </div>
                        </div>
                        <div v-if="userMessage.length" style="text-align: right; margin: 0"
                            class="popover_botton_content">
                            <el-button size="small" text @click="visible = false" class="">{{ langrage['dashboard37']
                            }}</el-button>
                            <el-button size="small" @click="changeType('')" color="#2b6bff" type="primary" class="">
                                {{ langrage['dashboard32'] }}
                            </el-button>
                        </div>
                    </div>
                    <template #reference>
                        <div class="popover-case" id="popover">
                            <img class="icon" :src="profile_notice" alt="" />
                        </div>
                    </template>
                </el-popover>
                <!-- <div class="btn flex-center" @click="jumpPage('/account/CDKEY')"
                    style="margin:0 2rem;justify-content: flex-start;padding:0 1rem;box-sizing: border-box;">
                    <img class="icon" :src="require('@/assets/images/center/Wallet_balance.png')" alt="" />
                    <span>${{ userInfo.user.walletBalance }}</span>
                </div> -->
                
                <div class="user-info flex-center popover-case" @click="jumpPage('/account/profile')">
                    
                    <el-dropdown class="flex-center">
                        <span><img class="avatar" :src="profile_avatar" alt="" /></span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item command="zh" @click="goMessage">{{ langrage['profile1']
                                }}</el-dropdown-item>
                                <el-dropdown-item command="es" @click="checkIn">{{ langrage['navbar4']
                                }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </template>

            <!-- 移动端显示简化版本 -->
            <template v-else>
                <div class="mobile-right-content">
                    <div class="mobile-language">
                        <language />
                    </div>
                    <div class="notification-wrapper" @click="toggleNotificationPanel">
                        <el-badge class="badge" :value="badge" :max="99" :offset="[3, -1]">
                            <img class="icon" :src="profile_notice" alt="" />
                        </el-badge>
                    </div>
                    <!-- <div style="font-size: 1.4rem">{{ userInfo.user.userName }}</div>
                    <div class="mobile-user-info" @click="jumpPage('/account/profile')">
                        <img class="avatar" :src="profile_avatar" alt="" />
                    </div> -->
                </div>
                <!-- 消息遮罩层 -->
                <div v-if="notificationVisible" class="mobile-message-mask" @click="notificationVisible = false"></div>
                <!-- 消息 -->
                <div v-if="notificationVisible" class="mobile-message-box">
                    <div class="panel-header">
                        <span>{{ langrage['dashboard31'] }}</span>
                        <button @click="notificationVisible = false" class="close-btn">×</button>
                    </div>

                    <div class="panel-content">
                        <div v-if="userMessage.length" class="message-list">
                            <div v-for="(item, index) in userMessage" :key="index" class="message-item">
                                <div class="message-text">{{ item.pushInfo }}</div>
                                <div class="message-action" @click="changeType(item)"
                                    :class="item.isRead == 2 ? 'read' : 'unread'">
                                    {{ item.isRead == 2 ? langrage['dashboard36'] : langrage['dashboard35'] }}
                                </div>
                            </div>
                        </div>
                        <!-- 暂无消息 -->
                        <div v-else class="empty-container">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
                            <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
                          </svg>
                          <div>{{ langrage['dashboard38'] }}</div>
                        </div>
                    </div>

                    <div v-if="userMessage.length" class="panel-footer">
                        <button @click="changeType('')" class="mark-all-read">
                            {{ langrage['dashboard32'] }}
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .blue {
        color: #6D28D9 !important;
    }

    .popover_content {
        background: #fff;
        border-radius: 14px;
        height: 320px;
        display: flex;
        flex-direction: column;

        .popover_title {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #fff;
            background: #2d2d2d;
            padding: 12px;
            border-radius: 15px 15px 0 0;
        }

        .popover_tip_content {
            flex: 1;
            overflow-y: auto;
            padding-right: 4px;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: #F9FAFB;
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background: #D1D5DB;
                border-radius: 3px;

                &:hover {
                    background: #9CA3AF;
                }
            }
        }

        .popover_text_content {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 12px 14px;
            margin-bottom: 6px;
            background: #FAFAFA;
            border-radius: 10px;
            transition: all 0.15s ease;
            cursor: pointer;

            &:hover {
                background: #F3F4F6;
                transform: translateX(4px);
            }

            .num_content {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                gap: 10px;
                flex: 1;
                min-width: 0;

                .num {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 24px;
                    height: 24px;
                    background: linear-gradient(135deg, #6D28D9, #8B5CF6);
                    color: #fff;
                    font-size: 12px;
                    font-weight: 600;
                    border-radius: 6px;
                    flex-shrink: 0;
                }

                .popover_text {
                    margin: 0;
                    font-size: 13px;
                    color: #374151;
                    line-height: 1.5;
                    word-break: break-word;
                    white-space: pre-wrap;
                }
            }

            .popover_type {
                color: #9CA3AF;
                font-size: 12px;
                font-weight: 500;
                cursor: pointer;
                padding: 4px 10px;
                border-radius: 6px;
                transition: all 0.15s;
                flex-shrink: 0;

                &:hover {
                    background: #EEF2FF;
                }
            }
        }

        .popover_botton_content {
            padding-top: 14px;
            border-top: 1px solid #F3F4F6;
            display: flex;
            justify-content: flex-end;
            gap: 10px;

            ::v-deep .el-button--text {
                font-size: 13px;
                color: #6B7280;
                font-weight: 500;
                padding: 8px 16px;

                &:hover {
                    color: #374151;
                    background: #F3F4F6;
                }
            }

            ::v-deep .el-button--primary {
                font-size: 13px;
                font-weight: 600;
                padding: 8px 20px;
                background: #297ee5;
                border-radius: 8px;
                border: none;

                &:hover {
                    background: #5B21B6;
                }
            }
        }
    }

    // otf-opentype
    // ttf-truetype
    @font-face {
        font-family: 'Custom1';
        src: url('@/assets/fonts/1.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom2';
        src: url('@/assets/fonts/2.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom3';
        src: url('@/assets/fonts/3.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom4';
        src: url('@/assets/fonts/4.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom5';
        src: url('@/assets/fonts/5.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom6';
        src: url('@/assets/fonts/6.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom7';
        src: url('@/assets/fonts/7.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Custom8';
        src: url('@/assets/fonts/8.otf') format('opentype');
    }

    ::v-deep {
        .el-breadcrumb {
            font-size: 1.4rem;
        }
    }

    .scroll {
        border: 1px solid red;
        width: 50rem;
        overflow: hidden;
    }

    .navbar {
        position: fixed;
        z-index: 9;
        width: -webkit-fill-available;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 7rem;
        background: #fff;
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border-bottom: 1px solid rgba(255, 255, 255, .06);
        box-sizing: border-box;
        padding: 0 2rem;

        .left {
            .icon {
                width: 4rem;
                height: 4rem;
                line-height: 5.4rem;
                text-align: center;
                cursor: pointer;

                img {
                    width: 2rem;
                    height: 2rem;
                }
            }

            .tips {
                font-weight: 400;
                font-size: 1.4rem;
                color: rgba(232, 236, 245, 1);
                margin-left: 5rem;
            }
        }

        .right {
            .btn {
                cursor: pointer;
                min-width: 10rem;
                height: 3.2rem;
                background: rgba(43, 127, 255, .12);
                border-radius: 10px;
                border: 1px solid rgba(43, 127, 255, .3);
                font-weight: 400;
                font-size: 1.4rem;
                color: rgba(232, 236, 245, 1);

                .icon {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                span {
                    font-weight: 400;
                    font-size: 1.4rem;
                    color: rgba(232, 236, 245, 1);
                    white-space: nowrap;
                }
            }

            .popover-case {
                min-width: 2.5rem;
                height: 3.5rem;
                display: flex;
                align-items: center;
                border-radius: 9px;
                padding: 0 0.7rem;
                background: rgba(255, 255, 255, .04);
                border: 1px solid rgba(255, 255, 255, .1);
                display: grid;
                place-items: center;
                color: rgba(180, 188, 208, 1);
                transition: all 0.2s;
                position: relative;
                
                .icon {
                    width: 2.5rem;
                    height: 2.5rem;
                    border-radius: 50%;
                }
            }
            
            .popover-case:hover {
                background: rgba(255, 255, 255, .08);
                border-color: rgba(255, 255, 255, .16);
                color: rgba(232, 236, 245, 1);
            }

            .badge {
                cursor: pointer;
            }

            .user-info {
                cursor: pointer;
                margin-right: 1rem;
                padding: 0 0.7rem;
                display: flex;
                align-items: center;
                gap: 10px;
                height: 3.5rem;
                background: rgba(255, 255, 255, .04);
                border: 1px solid rgba(255, 255, 255, .1);
                border-radius: 9px;
                transition: all 0.2s;

                &:hover {
                    border-color: rgba(43, 127, 255, .3);
                    background: rgba(43, 127, 255, .06);
                }

                span {
                    font-weight: 500;
                    font-size: 1.4rem;
                    color: rgba(232, 236, 245, 1);
                }

                .avatar {
                    width: 3rem;
                    height: 3rem;
                    border-radius: 50%;
                }
            }

            .select {
                cursor: pointer;

                ::v-deep {
                    .language-box {
                        display: flex;
                        position: relative;
                        top: auto;
                        right: auto;
                    }
                }

                img {
                    width: 3rem;
                    height: 2rem;
                    margin-right: 1rem;
                }

                .el-dropdown-link {
                    font-weight: 400;
                    font-size: 1.2rem;
                    color: rgba(232, 236, 245, 1);
                }

                .el-dropdown-link:focus-visible {
                    outline: none;
                }
            }
        }
    }

    ::v-deep {
        .el-popper.is-light {
            padding: 0;
            border-radius: 20px;
        }
        .el-dropdown-menu__item {
            font-size: 1.4rem;
        }

        .el-dropdown-menu__item:not(.is-disabled):focus,
        .el-dropdown-menu__item:not(.is-disabled):hover {
            color: #2b6bff;
        }

        .is-text {
            border: 1px solid #ccc !important;
        }
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    /* ============== 空状态 ============== */
    .empty-container {
      text-align: center;
      padding: 60px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    
      svg {
        width: 50px;
        height: 50px;
        opacity: 0.5;
        border:2px dashed #4e5362;
        border-radius:18px;
        padding:15px;
      }
    
      div {
        font-size: 16px;
        color: #9A9AB0;
        font-weight: 500;
      }
    }
    

    // 移动端样式
    .mobile-menu-icon {
        width: 4rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 2rem;
            height: 2rem;
        }
    }

    .mobile-right-content {
        display: flex;
        align-items: center;
        gap: 1rem;

        .badge {
            margin: 0;
        }

        .mobile-user-info {
            .avatar {
                width: 3rem;
                height: 3rem;
                border-radius: 50%;
            }
        }

        .mobile-language {
            ::v-deep {
                .language-box {
                    position: relative;
                    top: auto;
                    right: auto;
                    margin: 0;

                    .el-dropdown {
                        .el-dropdown-link {
                            color: #333;
                            font-size: 1.4rem;

                            img {
                                width: 2rem;
                                height: 1.5rem;
                                margin-right: 0.5rem;
                            }
                        }
                    }
                }
            }
        }
    }

    .mobile-message-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000000b5;
        z-index: 99;
        height: 100vh;
    }

    .mobile-message-box {
        position: absolute;
        top: 16rem;
        right: 0rem;
        left: 0rem;
        margin: auto;
        height: 50vh;
        width: 85%;
        background: white;
        border-radius: 14px;
        box-shadow: 0 10px 40px -10px rgba(0, 0, 0, 0.12);
        z-index: 100;

        .panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #fff;
            background: #2d2d2d;
            padding: 0 12px;
            border-radius: 10px 10px 0 0;

            h3 {
                margin: 0;
                font-size: 1.4rem;
            }

            .close-btn {
                color:#fff;
                background: none;
                border: none;
                font-size: 4rem;
                cursor: pointer;
                padding: 0;
            }
        }

        .panel-content {
            height: 30vh;
            overflow-y: auto;

            .message-list {
                .message-item {
                    padding: 1rem;
                    border-bottom: 1px solid #eee;

                    .message-text {
                        margin-bottom: 0.5rem;
                    }

                    .message-action {
                        color: #ccc;
                        cursor: pointer;

                        &.unread {
                            color: #2b6bff;
                        }
                    }
                }
            }
        }

        .panel-footer {
            padding: 1rem;
            text-align: right;

            .mark-all-read {
                background: #2b6bff;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 4px;
                cursor: pointer;
            }
        }
    }

    .notification-wrapper {
        position: relative;
    }

    /* ============== RESPONSIVE - 移动端 (max-width: 768px) ============== */
    @media screen and (max-width: 768px) {
        .navbar {
            height: 6rem;
            padding: 0 1rem;
            background: #34363bd9;
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
            border-bottom: 1px solid rgba(255, 255, 255, .06);

            .left {
                .mobile-menu-icon {
                    width: 3.6rem;
                    height: 3.6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #000;
                    border: 1px solid rgba(255, 255, 255, .1);
                    border-radius: 9px;
                    cursor: pointer;
                    transition: all 0.2s;

                    &:hover {
                        background: rgba(255, 255, 255, .08);
                        border-color: rgba(255, 255, 255, .16);
                    }

                    img {
                        width: 1.8rem;
                        height: 1.8rem;
                        filter: brightness(0) invert(1);
                    }
                }

                .tips {
                    display: none;
                }
            }

            .right {
                .btn {
                    display: none;
                }
                
                .badge {
                    img{
                        width: 3rem;
                        height: 3rem;
                        filter: brightness(0) invert(1);
                    }
                }

                .popover-case {
                    width: 3.8rem;
                    height: 3.8rem;
                    border-radius: 9px;
                    background: rgba(255, 255, 255, .04);
                    border: 1px solid rgba(255, 255, 255, .1);

                    svg {
                        width: 1.7rem;
                        height: 1.7rem;
                    }

                    &:hover {
                        background: rgba(255, 255, 255, .08);
                        border-color: rgba(255, 255, 255, .16);
                    }
                }

                .user-info {
                    display: none;
                }

                .select {
                    display: none;
                }
            }
        }
    }
</style>